import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, Loader2, Trophy, XCircle, Clock } from "lucide-react";

export function SignalsTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/signals").then(({ data }) => setData(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="py-16 text-center text-[#888]"><Loader2 className="h-6 w-6 animate-spin mx-auto" /></div>;

  const totals = data?.totals || { total: 0, wins: 0, losses: 0, win_rate: 0 };

  return (
    <div className="space-y-6" data-testid="signals-tab">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5">
        <Mini label="Total Siyal" value={totals.total} />
        <Mini label="WIN" value={totals.wins} color="#00F593" />
        <Mini label="LOSS" value={totals.losses} color="#ff5b5b" />
        <Mini label="Win Rate" value={`${totals.win_rate}%`} color="#1C8CFF" />
      </div>

      {(data?.sessions || []).length === 0 ? (
        <div className="border border-[#222] bg-[#0F0F0F] p-10 text-center text-[#888] text-sm rounded-sm">Pa gen siyal anrejistre ankò.</div>
      ) : (
        data.sessions.map((s) => (
          <div key={s.session_id} className="border border-[#222] bg-[#0F0F0F] rounded-sm overflow-hidden" data-testid={`signal-session-${s.session_id}`}>
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#161616]">
              <div className="flex items-center gap-2">
                <span className="font-heading font-semibold text-sm">{s.trading_session || s.session_id}</span>
                <span className="font-mono-term text-[10px] text-[#555]">{s.session_id}</span>
              </div>
              <div className="flex items-center gap-3 text-xs font-mono-term">
                <span className="text-[#00F593] flex items-center gap-1"><Trophy className="h-3 w-3" />{s.wins}</span>
                <span className="text-[#ff5b5b] flex items-center gap-1"><XCircle className="h-3 w-3" />{s.losses}</span>
                <span className="text-[#888] flex items-center gap-1"><Clock className="h-3 w-3" />{s.pending}</span>
                <span className="px-2 py-0.5 rounded-sm bg-[#1C8CFF]/15 text-[#1C8CFF] font-bold">{s.win_rate}%</span>
              </div>
            </div>
            <div className="max-h-64 overflow-y-auto">
              {s.signals.map((sig) => (
                <div key={sig.id} className="flex items-center justify-between px-4 py-2 border-b border-[#141414] last:border-0 text-xs">
                  <div className="flex items-center gap-2 min-w-0">
                    <span className={`font-bold ${sig.direction === "BUY" ? "text-[#00F593]" : sig.direction === "SELL" ? "text-[#ff5b5b]" : "text-[#888]"}`}>{sig.direction}</span>
                    <span className="text-white truncate">{sig.asset}</span>
                    <span className="text-[#666] font-mono-term">{sig.timeframe} · {sig.confidence}%</span>
                  </div>
                  <div className="flex items-center gap-2 shrink-0">
                    {sig.result === "WIN" && <span className="text-[#00F593] font-bold">WIN</span>}
                    {sig.result === "LOSS" && <span className="text-[#ff5b5b] font-bold">LOSS</span>}
                    {!sig.result && <span className="text-[#555]">—</span>}
                    <span className="text-[#555] font-mono-term">{(sig.generated_at || "").slice(11, 16)}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

function Mini({ label, value, color }) {
  return (
    <div className="bg-[#0A0A0A] border border-[#222] p-3 rounded-sm">
      <div className="font-mono-term text-[10px] uppercase tracking-widest text-[#888] mb-1">{label}</div>
      <div className="font-heading text-xl font-bold" style={color ? { color } : {}}>{value}</div>
    </div>
  );
}
